import { render } from "./excellentcourse.vue?vue&type=template&id=3c034658&scoped=true&ts=true"
import script from "./excellentcourse.vue?vue&type=script&lang=ts"
export * from "./excellentcourse.vue?vue&type=script&lang=ts"

import "./excellentcourse.vue?vue&type=style&index=0&id=3c034658&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c034658"]])

export default __exports__